export type IdfOAuthRedirect =
  | { type: "code"; code: string }
  | { type: "error"; reason: "access_denied" | "oauth_failed" };

/** Parse the public browser hand-off returned by the OAuth callback. */
export function parseIdfOAuthRedirect(search: string): IdfOAuthRedirect {
  const query = new URLSearchParams(search);
  const codes = query.getAll("code").map((code) => code.trim());
  const errors = query.getAll("error");

  if (codes.length === 1 && codes[0] && errors.length === 0) {
    return { type: "code", code: codes[0] };
  }

  if (
    codes.length === 0 &&
    errors.length === 1 &&
    errors[0] === "access_denied"
  ) {
    return { type: "error", reason: "access_denied" };
  }

  return { type: "error", reason: "oauth_failed" };
}
